import $ from "jquery";
import Plyr from "plyr";
import CONSTANT from "../../common/js/_constant";

const videoPlayer = {
    variables: {
        normalVideo: ".video_player",
        autoplayVideo: ".video_player--autoplay",
        normalVideoList: [],
        url: window.location.href,
    },
    methods: {
        autoPauseVideo: function () {
            // implement auto pause video when not in view using IntersectionObserver
            const options = {
                root: null,
                rootMargin: "0px",
                threshold: 0.5,
            };
            const observer = new IntersectionObserver(function (entries, observer) {
                entries.forEach(function (entry){
                    if (entry.intersectionRatio !== 1) {
                        videoPlayer.variables.normalVideoList.forEach(function (player) {
                            player.pause();
                        });
                    }
                });
            }, options);

           videoPlayer.variables.normalVideoList.forEach(function (player) {
                // Skip players whose Plyr setup bailed (no container) so one bad
                // entry can't abort observing the rest of the list.
                if (player.elements && player.elements.container instanceof Element) {
                    observer.observe(player.elements.container);
                }
            });
            
            return observer;
        },
        videoUtils: function (videoElement, options) {
            const videos = $(videoElement);
            const videoMap = videos
                .map(function () {
                    // Plyr names the YouTube iframe "Player for {title}" and the
                    // controls "Play {title}". Without a title the iframe was
                    // announced as "Player for " (WCAG 4.1.2), so pass the
                    // authored video title through.
                    let title = $(this).attr("data-video-title") || $(this).attr("title") || "";
                    // No authored title ("Video" is the template default): use the
                    // heading of the section the video sits in, so the frame is
                    // named after what the video is about (WCAG 4.1.2, N4).
                    if (!title || title === "Video") {
                        const heading = $(this).closest("section, .generic-container").find("h1, h2, h3").first().text().trim();
                        title = heading || title;
                    }
                    const player = new Plyr(this, title ? $.extend({}, options, { title: title }) : options);
                    videoPlayer.methods.keepFrameTitle(player, title);
                    videoPlayer.methods.removeDuplicatePlayText(player);
                    return player;
                })
                .get();
            return videoMap;
        },
        // For YouTube, Plyr looks the title up via noembed.com after "ready" and
        // copies the result over config.title — an empty or failed lookup left
        // the iframe titled "Player for ". Restore the authored title whenever
        // the iframe ends up with an empty/generic one; a real YouTube title is kept.
        keepFrameTitle: function (player, title) {
            if (player.provider !== "youtube" || typeof MutationObserver === "undefined") {
                return;
            }
            function getIframe() {
                return player.elements && player.elements.container
                    ? player.elements.container.querySelector("iframe")
                    : null;
            }
            function fixTitle() {
                const iframe = getIframe();
                const current = iframe ? iframe.getAttribute("title") || "" : "";
                // Empty "Player for " or YouTube's generic "YouTube video player"
                if (iframe && (/for\s*(video|undefined|null)?\s*$/i.test(current) || /^\s*youtube video player\s*$/i.test(current))) {
                    iframe.setAttribute("title", title && title !== "Video" ? `Video: ${title}` : "Video player");
                }
            }
            player.on("ready", function () {
                fixTitle();
                const iframe = getIframe();
                if (iframe) {
                    new MutationObserver(fixTitle).observe(iframe, { attributes: true, attributeFilter: ["title"] });
                }
            });
        },
        // Label in Name (WCAG 2.5.3). Plyr's play buttons carry an aria-label
        // that Plyr keeps updated ("Play, {title}" / "Pause") plus text that
        // audits read as the button's content:
        //  - the big overlay button: a hidden "Play" span (.plyr__sr-only) —
        //    dead text, since the aria-label is what's announced; removed.
        //  - the control-bar button: two hover tooltips, "Pause" and "Play",
        //    with CSS showing one at a time. Read together they become
        //    "PausePlay", which matches neither label. They're merged into one
        //    tooltip whose text follows the play state, so the tooltip looks
        //    the same and the button's text always matches its label.
        // Re-run on "ready" because YouTube players build their controls later.
        removeDuplicatePlayText: function (player) {
            function container() {
                return player.elements && player.elements.container;
            }
            function updateTooltip() {
                const root = container();
                if (!root) {
                    return;
                }
                root.querySelectorAll(".chli-play-tooltip").forEach(function (tip) {
                    tip.textContent = player.playing ? tip.dataset.pause : tip.dataset.play;
                });
            }
            function tidy() {
                const root = container();
                if (!root) {
                    return;
                }
                root.querySelectorAll('[data-plyr="play"] .plyr__sr-only').forEach(function (span) {
                    span.remove();
                });
                root.querySelectorAll('[data-plyr="play"]').forEach(function (button) {
                    const pressed = button.querySelector(".plyr__tooltip.label--pressed");
                    const notPressed = button.querySelector(".plyr__tooltip.label--not-pressed");
                    if (!pressed || !notPressed) {
                        return;
                    }
                    notPressed.dataset.play = notPressed.textContent;
                    notPressed.dataset.pause = pressed.textContent;
                    // No label-- classes: Plyr's CSS would hide it in one state
                    notPressed.classList.remove("label--not-pressed");
                    notPressed.classList.add("chli-play-tooltip");
                    pressed.remove();
                });
                updateTooltip();
            }
            tidy();
            player.on("ready", tidy);
            player.on("play", updateTooltip);
            player.on("pause", updateTooltip);
            player.on("ended", updateTooltip);
        },
        singleVideoPlay: function () {
            videoPlayer.variables.normalVideoList.forEach(function (player) {
                player.on("play", function () {
                    const others = $.grep(videoPlayer.variables.normalVideoList, function (other) {
                        return other !== player;
                    });
                    $.each(others, function (_, other) {
                        other.pause();
                    });
                });
            });
        },
        fixMobileClick: function () {
            $(".plyr__video-wrapper").on("click", function (e) {
                e.preventDefault();
                e.stopPropagation();
                const video = $(this).find("video").get(0);
                if (video) {
                    if (video.paused) {
                        video.play();
                    } else {
                        video.pause();
                    }
                } else {
                    videoPlayer.variables.normalVideoList.forEach(function (player) {
                        if (player.provider === "youtube") {
                            player.togglePlay();
                        }
                    });
                }
            });
        },
registerVideo: function (videoElement, options = CONSTANT.videoOption ,doNotSingle = true) {
    const newOptions = $.extend({}, CONSTANT.videoOption, options);
    const videoList = videoPlayer.methods.videoUtils(videoElement, newOptions);
    // Plyr returns a half-built instance (no `supported`, no container) when the
    // element is already set up (e.g. the same markup registered twice). Such an
    // instance throws on toggleControls/observe, so only wire up players whose
    // setup completed; the element's original player keeps working as before.
    const readyList = videoList.filter(function (player) {
        return player.supported && player.elements && player.elements.container;
    });
    videoPlayer.variables.normalVideoList.push(...readyList);
    readyList.forEach(function (player) {
        player.toggleControls(false);
        function getVideoTitle(player) {
//            const src = player.media.currentSrc || '';
//            const arr = src.split('/');
//            let videoTitle = arr.length > 0 ? arr[arr.length - 1].split('.')[0] : '';
//            videoTitle = videoTitle.replaceAll("%20", " ")
//                                   .replaceAll("%27", "'")
//                                   .replaceAll("%45", "-")
//                                   .replaceAll("%95", "_");
//            return videoTitle;
            let title = player.media.getAttribute('title');
            if(title == null){
             title = $(player.elements.container).siblings('.video-player--text-container').data('title');
            }
            return title != null ? title : "";
        }

        // function getPageSection(player){
        //     let pageSection = $(player.elements.container).closest(".aem-GridColumn").length ? $(player.elements.container).closest(".aem-GridColumn").eq(0).find(".heading-2").length ? $(player.elements.container).closest(".aem-GridColumn").eq(0).find(".heading-2").get(0).innerText.replace(/\n/g, '').trim() : "" :"";
        //     pageSection = pageSection == ''? $(player.elements.container).closest(".generic-container").closest('.generic-container').length ? $(player.elements.container).closest(".generic-container").closest('.generic-container').find(".heading-2").length ? $(player.elements.container).closest(".generic-container").closest('.generic-container').find(".heading-2").get(0).innerText.replace(/\n/g, '').trim() : "" : "" : "";
        //     return pageSection;
        // }
        function getPageSection(player) {
            const container = $(player.elements.container);
            
            // Check for .heading-2 within the nearest .aem-GridColumn
            let pageSection = container.closest(".aem-GridColumn").find(".heading-2").eq(0).text().trim();
            
            // If no .heading-2 found in .aem-GridColumn, check within the nearest .generic-container
            if (!pageSection) {
                const genericContainer = container.closest(".generic-container");
                pageSection = genericContainer.find(".heading-2").eq(0).text().trim();
                
                // If still no heading found, use the container class name or a default string
                if (!pageSection) {
                    pageSection = genericContainer.length ? "Section inside .generic-container" : "Unnamed Section";
                }
            }
        
            return pageSection.replace(/\n/g, '').trim();
        }
        

        let play25Flag = false;
        let play50Flag = false;
        let play75Flag = false;
        let completedFlag = false;
        player.on("play", function () {
            player.toggleControls(true);
            let videoTitle = getVideoTitle(player);
            let pageSection = getPageSection(player);
            if (videoTitle) {
                let obj = videoPlayer.methods.dataLayerObj("Play", videoTitle, "play", pageSection);
                createDataLayer("Video_Play", obj);
            }
        });

        player.on("pause", function () {
            let videoTitle = getVideoTitle(player);
            let pageSection = getPageSection(player);
            if (videoTitle) {
                let obj = videoPlayer.methods.dataLayerObj("Pause", videoTitle, "pause", pageSection);
                createDataLayer("Video_pause", obj);
            }
        });

        player.on("timeupdate", function () {
            const currentTime = player.currentTime;
            const totalTime = player.duration;
            let per = (currentTime / totalTime) * 100;

            if (Math.floor(per) >= 25 && !play25Flag) {
                play25Flag = true;
                let videoTitle = getVideoTitle(player);
                let pageSection = getPageSection(player);
                if (videoTitle) {
                    let obj = videoPlayer.methods.dataLayerObj("Play25%", videoTitle, "", pageSection);
                    createDataLayer("Video_Play25%", obj);
                }
            }

            if (Math.floor(per) >= 50 && !play50Flag) {
                play50Flag = true;
                let videoTitle = getVideoTitle(player);
                let pageSection = getPageSection(player)
                if (videoTitle) {
                    let obj = videoPlayer.methods.dataLayerObj("Play50%", videoTitle, "", pageSection);
                    createDataLayer("Video_Play50%", obj);
                }
            }

            if (Math.floor(per) >= 75 && !play75Flag) {
                play75Flag = true;
                let videoTitle = getVideoTitle(player);
                let pageSection = getPageSection(player);
                if (videoTitle) {
                    let obj = videoPlayer.methods.dataLayerObj("Play75%", videoTitle, "", pageSection);
                    createDataLayer("Video_Play75%", obj);
                }
            }

            if (Math.floor(per) === 99 && !completedFlag) {
                completedFlag = true;
                let videoTitle = getVideoTitle(player);
                let pageSection = getPageSection(player);
                if (videoTitle) {
                    let obj = videoPlayer.methods.dataLayerObj("Completed", videoTitle, "", pageSection);
                    createDataLayer("Video_completed", obj);
                }
            }
        });
        (!doNotSingle) && videoPlayer.methods.pauseBlogStories(player);
    });
    if (videoPlayer.variables.normalVideoList.length > 0 && doNotSingle) {
        videoPlayer.methods.singleVideoPlay();
        // videoPlayer.methods.fixMobileClick();
        videoPlayer.methods.autoPauseVideo();
    }
    return videoList;
},
pauseBlogStories: (player)=>{
    const playerElement = player.elements.container;
    const button  = $(playerElement).closest('.modal-body').find('.close-story');
    button.on(CONSTANT.eventsListners.CLICK,(e)=>{
        player.pause();
    })
},
        dataLayerObj: function (videoProgress, videoTitle, btnText, pageSection) {
            var obj = {
                'articleName': "",
                'blogCategory': "",
                'blogPageCategory': "",
                'buttonText': btnText,
                'pageSection': pageSection,
                'pageType' : document.querySelector("meta[name='template']").content == 'chli-base-page-template' ? videoPlayer.variables.url.includes("blog") ? "Blogs" : videoPlayer.variables.url.substring(videoPlayer.variables.url.indexOf(".com/"), videoPlayer.variables.url.lastIndexOf('/')  === ".com") && !videoPlayer.variables.url.substring(videoPlayer.variables.url.indexOf(".com/"), videoPlayer.variables.url.length-1).includes('/') ? "Home" : "Other Pages" : "Blog Details Page",
                'planOption': "",
                'productCategory' : document.getElementById('productCategoryName') ? document.getElementById('productCategoryName').value : "",
                'productName' : document.getElementById('productPlanName') ? document.getElementById('productPlanName').value : "",
                'question': "",
                'searchTerm': "",
                'videoTitle': videoTitle,
                'bannerName': "",
                'bannerType': "",
                'videoProgress': videoProgress
            }
            return obj;
        }
    },
};

export default videoPlayer;
